import { createSlice } from "@reduxjs/toolkit";

const patientSlice = createSlice({
    name: "patient",
    initialState: {
        info: null,
    },
    reducers: {
        clearPatient: (state, action) => {
            state.info = null;
        },
        setPatient: (state, action) => {
            state.info = action.payload;
        },
        setPatientData: (state, action) => {
            if (!action.payload) {
                return;
            }

            const keys = Object.keys(action.payload);

            keys.forEach((key) => {
                state.info[key] = action.payload[key];
            });
        },

        setPatientHealthData: (state, action) => {
            if (!action.payload) {
                return;
            }

            const keys = Object.keys(action.payload);

            keys.forEach((key) => {
                state.info.healthData[key] = action.payload[key];
            });
        },
    },
});

export const {
    clearPatient,
    setPatient,
    setPatientData,
    setPatientHealthData,
} = patientSlice.actions;

export default patientSlice.reducer;
